import { endpointTrading } from "_common/constants/common";
import api from "states/drivers";

const StockEndpoint = `${endpointTrading}/stock`;

export const StockApi = {
  getList: async ({ params }) =>
    await api
      .get(`${StockEndpoint}/list`, params)
      .then((result) => result.data.data),
  getInfo: async ({ params }) =>
    await api
      .get(`${StockEndpoint}/info`, params)
      .then((result) => result.data.data),
};
